import { useEffect, useState } from "react";
import totop from "../images/totop.png";

export default function Totop() {
  const [totopbtn, settotopbtn] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 1000) {
        settotopbtn(true);
      } else {
        settotopbtn(false);
      }
    });
  }, []);
  const scrollUp = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div>
      {totopbtn && (
        <button className="topBtn" title="Go to top" onClick={scrollUp}>
          <img src={totop} alt="^" />
        </button>
      )}
    </div>
  );
}
